import axios from 'axios'

import { checkKeycloakToken } from './auth/hooks/useKeycloakToken'

export const S3AdapterService = axios.create({
  baseURL: '/s3-adapter/api/v1',
})

S3AdapterService.defaults.headers.common = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
  'Content-Type': 'application/json',
}

S3AdapterService.interceptors.request.use(checkKeycloakToken)
